import {DateTime} from 'luxon';

export function toIsoDateTimeHelper(date: DateTime | null): string | null {
  return date?.toISO({includeOffset: false}) ?? null;
}
